import React, {
  useState, useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import { FieldSelect } from 'components/molecules';
import { queryNewsCategories, queryNewsChannel } from 'services/requests';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useParams } from 'react-router-dom'
import queryString from 'query-string'

const AgendaSchema = Yup.object().shape({
  categorie: Yup.number(),
  channel: Yup.number(),
})

const computeOptions = (opts, valueKey = 'id', labelKey = 'name') => opts.map((option) => ({
  value: option[valueKey],
  label: option[labelKey],
  original: option
}))

const AgendaEditor = ({ initialProps, onChange }) => {
  const [categories, setCategories] = useState([]);
  const [channels, setChannel] = useState([]);
  const [isLoading, setLoading] = useState(true)
  const { lang } = useParams()

  const initialValues = useMemo(() => {
    const { endpoint } = initialProps
    const search = endpoint.split('?', 2)[1] || ''
    const { channel, categorie } = queryString.parse(search, { parseNumbers: true })

    return {
      channel: channel || 57,
      categorie: categorie || 0,
    }
  }, [initialProps])

  useEffect(() => {
    const getFieldsOptions = async () => {
      try {
        setLoading(true)
        const { data: { data: catData } } = await queryNewsCategories({ language: lang });
        const { data: { data: channelData } } = await queryNewsChannel({ language: lang });

        setCategories([
          {
            value: 0,
            label: 'Todas'
          },
          ...computeOptions(catData)
        ]);
        setChannel(computeOptions(channelData));

        setLoading(false)
      } catch (err) {
        setLoading(false)
        toast.error(
          <Toast
            type="error"
            title="Erro a carregar formulário de Notícias"
            description={err.message}
          />
        );
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
    getFieldsOptions();
  }, [lang]);

  const handleFormChange = (newValues) => {
    const newQuery = queryString.stringify(newValues)
    const newEndpoint = `/calendar?${newQuery}`

    const newProps = {
      ...initialProps, endpoint: newEndpoint
    };
    onChange(newProps);
  }

  if (isLoading) {
    return (
      <div>
      A carregar...
      </div>
    )
  }

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={AgendaSchema}
        validate={handleFormChange}
        enableReinitialize
      >
        <Form>
          <Field
            title="Categoria"
            name="categorie"
            options={categories}
            component={FieldSelect}
            placeholder="Selecione uma categoria..."
          />
          <Field
            title="Canal"
            name="channel"
            placeholder="Selecione um canal.."
            info="Indique o canal onde pretende obter as suas notícias. Este pode ser o canal geral da UA, do seu departamento, subweb, ou qualquer outra escolha."
            component={FieldSelect}
            options={channels}
          />
        </Form>
      </Formik>
    </div>
  );
}

AgendaEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    endpoint: PropTypes.string,
  }),
};
AgendaEditor.defaultProps = {
  initialProps: {},
};

export default AgendaEditor
